import React from 'react';
import { withRouter } from 'react-router-dom';
import { StringUtil } from 'utils/StringUtil';
import VideoInfoModuleMobile from 'components/templates/videoInfoModuleMobile';
import { ShareButton } from 'components/atoms/shareButton';
import { BookTableButton } from 'components/atoms/bookTableButtonMobile';
import { useViewport } from 'components/templates/viewportProvider';
import './styles.scss';

const CraftBeerSectionMobile = props => {
  const { height } = useViewport();
  const {
    craftBeerSectionData: {
      heading,
      video,
      sub_heading_mobile,
      paragraph_mobile,
      video_thumbnail_url,
    },
    beerData,
    showLineUpButton = false,
    noPadding = false,
  } = props.data;

  let description = StringUtil.sliceHtml(paragraph_mobile);

  const handleClick = () => {
    let element = document.getElementById('beer-explorer');
    element.scrollIntoView();
  };

  return (
    <div className={'module-container'} style={{ height }}>
      <VideoInfoModuleMobile
        heading={heading}
        subHeading={sub_heading_mobile}
        videoData={video}
        videoThumbnailUrl={video_thumbnail_url}
        content={description}
        variablePadding={noPadding}
        buttonName={
          showLineUpButton && beerData && beerData.length > 0
            ? 'VIEW OUR LINEUP'
            : null
        }
        onClick={handleClick}
      />
    </div>
  );
};

export default withRouter(CraftBeerSectionMobile);
